import { DataModel } from "../../base/index.js";
import type { InitMfaResponseData } from "./types.js";

export class MfaInit extends DataModel<InitMfaResponseData> {
  public readonly secret: string;
  public readonly barcodeImageSrc: string;

  public constructor(data: InitMfaResponseData) {
    super(data);
    this.secret = data.url.split("secret=")[1] ?? "";
    this.barcodeImageSrc = `data:image/jpg;base64, ${data.barcode}`;
  }
}
